.header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header p {
  min-width: 100px;
}

.accordionGreen {
  border: none;
  background-color: #f8fffa !important;
}

.accordionBlue {
  border: none;
  background-color: #f6faff !important;
}

.accordionRed {
  border: none;
  background-color: #fff7f5 !important;
}

.accordionGrey {
  border: none;
  background-color: #f2f2f2 !important;
}

.accordionWhite {
  border: 1px solid #b3b3b3;
  background-color: white;
}

.badgeGreen {
  border-radius: 4px;
  color: white;
  background-color: #02883f;
}

.badgeBlue {
  border-radius: 4px;
  color: white;
  background-color: #0d4eb1;
}

.badgeRed {
  border-radius: 4px;
  color: white;
  background-color: #be1d05;
}

.badgeBlack {
  border-radius: 4px;
  color: white;
  background-color: #333;
}

.loading {
  display: flex;
  justify-content: center;
}

.noHistory {
  text-align: center;
  padding: 1rem;
  color: #666;
}

.slideLeft {
  --slide-distance: 15%;
  composes: slideLeft from global;
}

.slideRight {
  --slide-distance: -15%;
  composes: slideRight from global;
}
